export class BackupProgress {
    static standBy = 0;
    static inProgress = 1;
    static done = 2;
    static failed = 3;
}